import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b199bf4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5b199bf4&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=5b199bf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b199bf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xushanB/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b199bf4')) {
      api.createRecord('5b199bf4', component.options)
    } else {
      api.reload('5b199bf4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5b199bf4&scoped=true&", function () {
      api.rerender('5b199bf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/config/overview/index.vue"
export default component.exports